export const TABLE_PER_PAGE = 50;
